import React from "react";
import ShowroomDirectory from "./ShowroomDirectory";
export default function ShowroomsSearch() { return <ShowroomDirectory />; }

